var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWrappedShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 13
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3798 30.75H17.6198C13.8398 30.75 10.8698 28.37 10.0498 24.68L9.63979 22.82C9.35979 21.54 10.0898 20.16 11.2998 19.67L18.2298 16.89C19.3698 16.44 20.6298 16.44 21.7698 16.89L28.6998 19.67C29.9198 20.16 30.6498 21.54 30.3598 22.82L29.9498 24.68C29.1298 28.37 26.1598 30.75 22.3798 30.75ZM19.9998 18.05C19.5898 18.05 19.1798 18.13 18.7798 18.28L11.8498 21.06C11.3198 21.27 10.9698 21.94 11.0898 22.49L11.4998 24.35C12.1698 27.37 14.5098 29.24 17.6098 29.24H22.3698C25.4698 29.24 27.8098 27.37 28.4798 24.35L28.8898 22.49C29.0098 21.94 28.6598 21.27 28.1298 21.06L21.1998 18.28C20.8198 18.13 20.4098 18.05 19.9998 18.05Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.75C19.59 30.75 19.25 30.41 19.25 30V18C19.25 17.59 19.59 17.25 20 17.25C20.41 17.25 20.75 17.59 20.75 18V30C20.75 30.41 20.41 30.75 20 30.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0002 20.55C26.9102 20.55 26.8102 20.53 26.7202 20.5L21.2102 18.29C20.4302 17.98 19.5702 17.98 18.7802 18.29L13.2702 20.5C13.0402 20.59 12.7803 20.56 12.5703 20.42C12.3603 20.28 12.2402 20.05 12.2402 19.8V16C12.2402 13.93 13.9202 12.25 15.9902 12.25H23.9902C26.0602 12.25 27.7402 13.93 27.7402 16V19.8C27.7402 20.05 27.6202 20.28 27.4102 20.42C27.2902 20.51 27.1502 20.55 27.0002 20.55ZM20.0002 16.55C20.6002 16.55 21.2002 16.66 21.7702 16.89L26.2502 18.69V16C26.2502 14.76 25.2402 13.75 24.0002 13.75H16.0002C14.7602 13.75 13.7502 14.76 13.7502 16V18.69L18.2303 16.89C18.8003 16.67 19.4002 16.55 20.0002 16.55Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 13.75H17.5C17.09 13.75 16.75 13.41 16.75 13V11C16.75 10.04 17.54 9.25 18.5 9.25H21.5C22.46 9.25 23.25 10.04 23.25 11V13C23.25 13.41 22.91 13.75 22.5 13.75ZM18.25 12.25H21.75V11C21.75 10.86 21.64 10.75 21.5 10.75H18.5C18.36 10.75 18.25 10.86 18.25 11V12.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrappedShip);
export default __webpack_public_path__ + "static/media/wrapped-ship.fb6a219c9e46654c650d120e24e617af.svg";
export { ForwardRef as ReactComponent };